import { QueryResources } from '@/lib/datx-jsonapi-react';
import { MutationFn } from '@/lib/datx-jsonapi-react/interfaces/MutaionFn';
import { Reaction } from '@/resources/Reaction';

export const queryCommentReactions = (
  commentId?: string | Array<string>,
  userId?: string
): QueryResources<Reaction> => {
  if (!userId || !commentId) return;
  return [Reaction.type, { filter: { comment_id: commentId, user_id: userId } }];
};

export interface ICreateCommentReactionInput {
  type: string;
  commentId: string;
}

export const createCommentReaction: MutationFn<ICreateCommentReactionInput, Reaction> = (
  store,
  { type, commentId }: ICreateCommentReactionInput
) => {
  return store.request<Reaction>(`reactions`, 'POST', {
    data: {
      type: 'reactions',
      attributes: {
        type,
      },
      relationships: {
        comment: {
          data: {
            type: 'comments',
            id: commentId,
          },
        },
      },
    },
  });
};

export interface IDestroyCommentReactionInput {
  reactionId: string;
}

export const destroyCommentReaction: MutationFn<IDestroyCommentReactionInput, Reaction> = (
  store,
  { reactionId }: IDestroyCommentReactionInput
) => {
  return store.request<Reaction>(`reactions/${reactionId}`, 'DELETE');
};
